import React from "react";
import PageHero from "@/components/PageHero";
import FinalCTA from "@/components/FinalCTA";
import SectionHeading from "@/components/SectionHeading";
import { Landmark, HeartPulse, ShoppingBag, Factory, GraduationCap, Cpu, Building2, Truck } from "lucide-react";

const INDUSTRIES = [
  { icon: Landmark, title: "BFSI", desc: "Banking, NBFCs and fintech — DPDP, RBI, ISO and 24/7 SOC coverage." },
  { icon: HeartPulse, title: "Healthcare", desc: "Patient data protection, HIPAA/DPDP and ransomware resilience." },
  { icon: ShoppingBag, title: "Retail & E-commerce", desc: "Payment, app and bot fraud protection across digital storefronts." },
  { icon: Factory, title: "Manufacturing", desc: "OT/IT segmentation, ransomware containment and supply chain risk." },
  { icon: GraduationCap, title: "Education", desc: "Campus, student data and awareness for K-12 and higher ed." },
  { icon: Cpu, title: "SaaS / Tech", desc: "Cloud-native security, SOC 2 readiness and secure SDLC." },
  { icon: Building2, title: "Government", desc: "Critical infrastructure, audits and DPDP-aligned governance." },
  { icon: Truck, title: "Logistics", desc: "API security, account takeover defense and partner trust." },
];

export default function Industries() {
  return (
    <div data-testid="industries-page">
      <PageHero
        eyebrow="Industries"
        title="Trusted across regulated and high-growth industries"
        description="Cosmos Defence tailors security programs to your sector's threat profile, regulators and digital maturity."
      />

      <section className="py-20 bg-white">
        <div className="container-cd">
          <SectionHeading eyebrow="Verticals" title="Sector-specific playbooks" />
          <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {INDUSTRIES.map((it, i) => (
              <div key={it.title} className="card-cd" data-testid={`industry-card-${i}`}>
                <span className="h-12 w-12 grid place-items-center rounded-xl bg-gradient-to-br from-blue-500/10 to-purple-500/10 border border-blue-100">
                  <it.icon size={22} className="text-[#3B82F6]" strokeWidth={1.6} />
                </span>
                <h3 className="mt-5 font-display text-lg font-bold text-[#0A1B5E]">{it.title}</h3>
                <p className="mt-2 text-slate-600 text-sm leading-relaxed">{it.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <FinalCTA />
    </div>
  );
}
